import { render, staticRenderFns } from "./TagCell.vue?vue&type=template&id=1c4457e4&scoped=true&"
import script from "./TagCell.vue?vue&type=script&lang=js&"
export * from "./TagCell.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TagCell.vue?vue&type=style&index=1&id=1c4457e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4457e4",
  null
  
)

export default component.exports